module.exports = __webpack_public_path__ + "images/file_icons_v2/otf-eb6f6be82e7ed2f7e611c5708114bc11.svg";